import axios from '@/http/axios';
import {route} from '@/http/ziggy';

/**
 * Shows an experiment.
 *
 * @param experiment
 *
 * @return {Promise}
 */
export const show = ({experiment}) => axios.get(route('catchers.core.experiments.show', {experiment}));

/**
 * Fetch the current experiment of the authed User.
 *
 * @return {Promise}
 */
export const myExperiment = () => axios.get(route('catchers.core.experiments.my_experiment'));

/**
 * Fetch the current score details for the given experiment.
 *
 * @param experiment
 *
 * @return {Promise}
 */
export const scoreDetails = ({experiment}) => axios.get(route('catchers.scoring.experiment.score_details', {experiment}));

/**
 * Update user redeem points.
 *
 * @param experiment
 *
 * @return {Promise}
 */
export const redeemPoints = ({experiment}) => axios.put(route('catchers.scoring.experiment.score.redeem_points', {experiment}));

/**
 * Fetch the experiment consent terms and user.
 *
 * @param experiment
 * @param user
 *
 * @return {Promise}
 */
export const pendingConsentDetails = ({experiment, user}) => axios.get(route('catchers.core.experiments.pending_consent_details', {experiment, user}));

export default {
  show,
  myExperiment,
  pendingConsentDetails,
  scoreDetails,
  redeemPoints,
}
